module.exports = __webpack_public_path__ + "static/imbibe_wilbert_long.dfb42123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imbibe_wilbert_long.png
// module id = 537
// module chunks = 35783957827783